import './App.css';
import './css/navbar.css'
import Index from './pages/Index';
import { BrowserRouter as Router, Link, NavLink, Routes, Route } from 'react-router-dom';
import Entreprise from './pages/Entreprise';
import Competences from './pages/Competences';
import Realisations from './pages/Realisations';
import Contact from './pages/Contact';
import { ToastContainer } from 'react-toastify';
import { Helmet } from 'react-helmet';

function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}


const App = () => {
  return (
    <Router>
      <nav style={{ display: "none" }} class="navbar navbar-default navbar-fixed-top">
        <div class="container-fluid paddingBottom8px">
          <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#myNavbar" data-bs-toggle="collapse" data-bs-target="#myNavbar" aria-controls="myNavbar" aria-expanded="false" aria-label="Toggle navigation">
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <div class="nav-logo-wrap local-scroll marginTop">
              <NavLink
                to="/"
                className={({ isActive }) => (isActive ? "linkItemRed" : "linkItem")}
                onClick={() => topFunction()}
              >
                <img src="assets/images/logo-dark.png" class="logoNavBar" width="100" height="27" alt="" />
              </NavLink>
            </div>
          </div>
          <div class="collapse navbar-collapse" id="myNavbar">
            <div class="nav navbar-nav navbar-right marginTop15 fontSizeNavLinks">
              <NavLink
                to="/entreprise"
                id="entreprise"
                className={({ isActive }) => (isActive ? "linkItemRed" : "linkItem")}
                onClick={() => topFunction()}
              >
                Qui sommes-nous
              </NavLink>
              <NavLink
                to="/competence"
                id="competence"
                className={({ isActive }) => (isActive ? "linkItemRed" : "linkItem")}
                onClick={() => topFunction()}
              >
                Compétences
              </NavLink>
              <NavLink
                to="/realisation"
                id="realisation"
                className={({ isActive }) => (isActive ? "linkItemRed" : "linkItem")}
                onClick={() => topFunction()}
              >
                Nos Réalisations
              </NavLink>
              <NavLink
                to="/contact"
                id="contact"
                className={({ isActive }) => (isActive ? "linkItemRed" : "linkItem")}
                onClick={() => topFunction()}
              >
                Devis et Contact
              </NavLink>
            </div>
          </div>
        </div>
      </nav>
      <ToastContainer
        autoClose={2000}
        hideProgressBar={true} />

      <Helmet>
      <meta name="description" content="Décohome75 est une entreprise de rénovation intégrale pour maison basée à Paris, France, spécialisée dans les rénovations de salle de bain, cuisine, murs et sols. Nous proposons des services de maçonnerie, plomberie, menuiserie, peinture et plâtrerie, électricité générale, parqueterie et carrelage." />
        <meta name="keywords" content="rénovation, maison, rénovation intégrale, rénovation complète, salle de bain, cuisine, murs et sols, maçonnerie, plomberie, menuiserie, peinture et plâtrerie, électricité générale, parqueterie, carrelage" />
      </Helmet>
      <Routes>
        <Route path='/' element={<Index />} />
        <Route path='/entreprise' element={<Entreprise />} />
        <Route path='/competence' element={<Competences />} />
        <Route path='/realisation' element={<Realisations />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/*' element={<Index />} />
      </Routes>

    </Router>
  );
};

export default App;